/**
 * Revenue-model constants for the warehousing project setup step.
 *
 * Revenue is computed server-side by `warehouse_revenue_engine.py`; nothing here
 * duplicates that maths.
 *
 * Leaf module: no imports, so it can never take part in a cycle.
 */

export const REVENUE_MODEL_PER_ORDER = 'per_order_slab';
export const REVENUE_MODEL_COST_PLUS = 'cost_plus';

export const REVENUE_MODEL_OPTIONS = [
	{
		value: REVENUE_MODEL_PER_ORDER,
		label: 'Per Order (Slab based)',
		description: 'Revenue is billed per shipment based on volume slabs.',
	},
	{
		value: REVENUE_MODEL_COST_PLUS,
		label: 'Cost Plus',
		description: 'Revenue = total operational cost + fixed margin %.',
	},
];

export const SLAB_MIN_ROWS = 1;
export const SLAB_MAX_ROWS = 25;

export const makeEmptySlab = (slabMin = 0) => ({
	slab_min: slabMin,
	slab_max: '',
	rate_per_order: '',
});

export const makeDefaultSlabs = () => [makeEmptySlab(0)];

/**
 * Cross Dock — a single flat rate per bag, layered on top of the base revenue model.
 *
 * One rate applies per bag regardless of how many shipments are inside it, so this is a
 * plain number, not a slab structure and not an extensible list of charge types.
 *
 * The API keeps a generic `additional_charges` collection keyed by `basis`, so the form's
 * single rate is sent as (and read back from) the one row whose basis is 'per_bag'.
 */
export const CHARGE_BASIS_PER_BAG = 'per_bag';
export const CROSS_DOCK_CHARGE_HEAD = 'Cross Dock';

/** Pull the Cross Dock rate out of the API's generic charge list. */
export const crossDockRateFrom = (charges) => {
	const match = (charges || []).find((charge) => charge?.basis === CHARGE_BASIS_PER_BAG);
	if (!match || match.rate === null || match.rate === undefined || match.rate === '') return '';
	return match.rate;
};

/** Wrap the form's single rate back into the API's charge list shape. */
export const crossDockChargeList = (rate) => {
	if (rate === '' || rate === null || rate === undefined) return [];
	const numeric = Number(rate);
	if (Number.isNaN(numeric) || numeric <= 0) return [];
	return [{ charge_head: CROSS_DOCK_CHARGE_HEAD, basis: CHARGE_BASIS_PER_BAG, rate: numeric }];
};
